import { createSelector } from 'reselect';
import { RootState } from '../state';
import Equipment from '../../types/model/Equipment';

export const selectEquipment = (state: RootState) => state.equipment.byId;

export const selectEquipmentById = createSelector([selectEquipment, (_, id: number) => id], (equipmentById, id): Equipment => equipmentById[id]);
